import { Address } from './address-types';

/**
 * Client demographic enums used in matter client profiles.
 */
export const Gender = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other',
} as const;

export type GenderValue = (typeof Gender)[keyof typeof Gender];

export const PreferredLanguage = {
  ENGLISH: 'English',
  SPANISH: 'Spanish',
  ARABIC: 'Arabic',
} as const;

export type PreferredLanguageValue =
  (typeof PreferredLanguage)[keyof typeof PreferredLanguage];

/** Canonical list of language options for dropdowns. Single source of truth. */
export const PREFERRED_LANGUAGE_OPTIONS: readonly {
  readonly value: PreferredLanguageValue;
  readonly label: string;
}[] = [
  { value: PreferredLanguage.ENGLISH, label: 'English' },
  { value: PreferredLanguage.SPANISH, label: 'Spanish' },
  { value: PreferredLanguage.ARABIC, label: 'Arabic' },
] as const;

export interface MatterClient {
  id: string;
  person_id?: string;
  matter: string;
  name: string;
  email: string;
  date_of_birth: string;
  last_four_of_ssn?: string;
  preferred_language?: PreferredLanguageValue;

  gender?: GenderValue;
  first_name?: string;
  last_name?: string;
  ssn?: string;

  address: Address;
  phone_numbers: MatterClientPhoneNumber[];
}

export interface MatterClientPhoneNumber {
  id: string;
  phone_number: string;
}
